import type { Translation } from '../translations.types';

const translations: Translation = {
  logout: 'Déconnexion',
  openMenu: 'Ouvrir le menu',
  closeMenu: 'Fermer le menu',
  author: 'Publié par',
  'media': 'Média',
  'media.video': 'Vidéo',
  'media.image': 'Image',
  'add-review': 'Miam ! Partagez votre expérience culinaire !',
  'add-review-to-food': 'Parlez-nous de votre expérience avec {{food}}',
  food: {
    title: 'Nourriture',
    gourmets: 'Fans de {{food}}',
    bestPlaces: 'Meilleurs endroits pour {{food}}',
    gourmetsSectionDescription:
      "Découvrez qui connaît bien {{food}} ! Nos gourmets sont classés selon le nombre de fois qu'ils l'ont essayé et ce qu'ils en ont pensé.",
    bestPlacesSectionDescription:
      "Vous cherchez du {{food}} incroyable ? Ces endroits sont notés par des personnes qui s'y connaissent !",
    beTheFirstReviewer: {
      title: 'Soyez le premier à évaluer {{foodName}} !',
      description: 'Votre expérience culinaire compte ! Partagez votre avis et aidez les autres gourmets à découvrir ce plat.',
      button: 'Écrire le premier avis'
    }
  },
  drink: 'Boisson',
  place: 'Lieu',
  'where-did-you-eat': 'Où avez-vous mangé cela ?',
  'what-did-you-eat': "Qu'avez-vous essayé ?",
  localeCurrency: 'Devise locale',
  category: 'Catégorie',
  name: 'Nom',
  rating: 'Votre note',
  welcome_modal: {
    title: 'Bienvenue sur BiteCritic !',
    subtitle: 'Découvrez votre prochaine bouchée préférée',
    description:
      "BiteCritic est une communauté d'amateurs de nourriture qui partagent leurs expériences et évaluent les plats qu'ils ont essayés.",
    features: {
      title: 'Avec BiteCritic, vous pouvez :',
      rate: 'Évaluer les plats selon leur goût, pas seulement les restaurants',
      discover: 'Découvrir de nouveaux aliments basés sur des avis authentiques',
      connect: "Vous connecter avec d'autres passionnés de nourriture",
      track: 'Suivre les plats que vous souhaitez essayer'
    },
    not_now: 'Pas maintenant',
    join_now: 'Rejoindre maintenant'
  },
  review: {
    label: 'Votre Avis',
    writingIn: 'Je rédige cet avis en',
    success: 'Votre histoire est en ligne !',
    error: 'Oups ! Un problème est survenu lors du partage de votre histoire',
    foodReviewTitle: 'Avis sur {{foodName}} par {{username}} chez {{placeName}}, {{city}}',
    drinkReviewTitle: 'Avis sur {{drinkName}} par {{username}} chez {{placeName}}, {{city}}',
  },
  previous: 'Retour',
  next: 'Suivant',
  'submit-review': 'Partagez votre histoire',
  cancel: 'Annuler',
  type: 'Quel type',
  'add-food-review': "Qu'avez-vous mangé ?",
  'select-food': 'Choisissez votre plat',
  cost: 'Combien ?',
  'rating-explanation': 'Évaluez votre expérience avec ce plat.',
  'write-your-review': 'Racontez-nous tout...',
  'visited-at': 'Quand y êtes-vous allé ?',
  reviews: {
    noReviews: 'Aucun avis trouvé',
    readFull: "Lire l'histoire complète",
    showTranslation: 'Afficher la traduction',
    showOriginal: "Afficher l'original",
    translatedFrom: 'Traduit du {{language}}',
    filters: {
      title: 'Filtres',
      apply: 'Appliquer les filtres',
      rating: 'Note',
      cost: 'Prix',
      startDate: 'De',
      endDate: 'À',
      location: 'Emplacement',
      radius: 'Rayon de recherche (km)',
      sort: {
        label: 'Trier par',
        newest: "Plus récents d'abord",
        oldest: "Plus anciens d'abord",
        mostLiked: 'Mieux notés',
        leastLiked: 'Moins bien notés',
        mostExpensive: 'Plus chers',
        cheapest: 'Moins chers',
      },
      sortOrder: {
        asc: 'croissant',
        desc: 'décroissant',
      },
      sortBy: {
        createdAt: 'Date',
        likeCount: "J'aime",
        cost: 'Prix',
      },
      active: {
        rating: 'Note minimale : {{value}}',
        startDate: 'De : {{date}}',
        endDate: 'À : {{date}}',
        cost: 'Prix minimum : {{value}}',
        radius: 'Dans un rayon de {{value}}km',
      },
    },
  },
  languages: {
    en: 'Anglais',
    nl: 'Néerlandais',
    tr: 'Turc',
    de: 'Allemand',
    fr: 'Français',
    es: 'Espagnol',
    it: 'Italien',
    pt: 'Portugais',
    select: 'Sélectionner la langue',
  },
  validation: {
    'place-required': "Oups ! Choisissez d'abord un lieu",
    'category-required': 'Choisissez une catégorie !',
    'review-min-length':
      'Un peu plus de détails serait génial (au moins 80 caractères)',
    'rating-required': "N'oubliez pas de le noter !",
    'cost-positive': 'Le prix doit être supérieur à zéro',
    'visited-at-required': 'Quand y êtes-vous allé ?',
    'type-required': 'Nourriture ou boisson ?',
    'food-required': "Qu'avez-vous mangé ?",
    'drink-required': "Qu'avez-vous bu ?",
    'country-required': "D'où venez-vous ?",
    required: 'Ce champ est obligatoire',
  },
  auth: {
    welcomeBack: 'Bonjour ! 👋',
    loginToContinue: 'Reconnectez-vous',
    continueWithGoogle: 'Continuer avec Google',
    continueWithApple: 'Continuer avec Apple',
    logout: 'À bientôt !',
    login: 'Connexion',
    signup: "S'inscrire",
    required: 'Commençons !',
    actionRequiresAuth: 'Oups ! Une connexion rapide est nécessaire pour cela',
    alreadyLoggedIn: 'Vous êtes déjà connecté !',
    goToProfile: 'Aller au Profil',
    continueToFeed: 'Continuer vers le Fil',
    benefits: {
      title: 'Voici ce que vous manquez :',
      follow: 'Suivez vos plats préférés',
      review: 'Partagez vos aventures culinaires',
      save: 'Enregistrez des lieux pour plus tard',
      community: "Rencontrez d'autres amateurs de nourriture",
      personalized: 'Recevez des conseils culinaires rien que pour vous',
    },
    cta: {
      login: 'Allons-y !',
      cancel: 'Peut-être plus tard'
    },
    actions: {
      followFood: 'Connexion rapide pour suivre ce délicieux plat !',
      unfollowFood: 'Connectez-vous pour ne plus suivre',
    },
    joinNow: 'Rejoignez-nous maintenant !',
    joinCommunity: 'Rejoignez la fête culinaire !',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    signupToContinue: 'Rejoignez la fête culinaire !',
  },
  profile: {
    follow: 'Suivre',
    unfollow: 'Ne plus suivre',
    followers: 'Abonnés',
    following: 'Abonnements',
    avatar: 'Votre photo',
    change_avatar: 'Nouvelle photo',
    upload_avatar: 'Télécharger une photo',
    title: 'Votre profil',
    view: 'Voir le profil',
    username: "Nom d'utilisateur",
    email: 'Email',
    success: "Ça a l'air bien !",
    error: "Oups, quelque chose s'est mal passé",
    save: 'Enregistrer',
    firstName: 'Prénom',
    lastName: 'Nom',
    birthDate: 'Date de naissance',
    country: 'Pays',
    bio: 'À propos de vous',
    bioPlaceholder: 'Parlez-nous de vos aventures culinaires...',
    selectCountry: 'Sélectionnez votre pays',
    deleteAccount: {
      button: 'Supprimer le compte',
      title: 'Supprimer votre compte',
      warning: 'Attention : Cette action ne peut pas être annulée. Toutes vos données, avis et préférences seront définitivement supprimés.',
      confirm: 'Supprimer mon compte',
      error: 'Échec de la suppression du compte. Veuillez réessayer plus tard.'
    },
    noAccount: "Vous n'avez pas de compte ?",
  },
  errors: {
    invalidFileType:
      'Type de fichier invalide. Veuillez télécharger uniquement des images JPG, PNG, WebP, HEIC ou HEIF.',
    fileTooLarge:
      'Le fichier est trop volumineux. La taille maximale est {{size}}.',
    tooManyFiles: 'Trop de fichiers. Le maximum autorisé est {{max}}.'
  },
  onboarding: {
    welcome: 'Bienvenue sur BiteCritic !',
    setup_profile: 'Configurons votre profil',
    username: "Nom d'utilisateur",
    username_required: "Le nom d'utilisateur est obligatoire",
    username_min_length:
      "Le nom d'utilisateur doit comporter au moins 3 caractères",
    username_pattern:
      'Seuls les lettres, les chiffres et les tirets bas sont autorisés',
    username_taken: "Ce nom d'utilisateur est déjà pris",
    username_available: "Nom d'utilisateur disponible !",
    username_requirements:
      "Le nom d'utilisateur doit comporter au moins 3 caractères et ne peut contenir que des lettres, des chiffres et des tirets bas",
    checking_username:
      "Vérification de la disponibilité du nom d'utilisateur...",
    first_name: 'Prénom',
    first_name_required: 'Le prénom est obligatoire',
    first_name_min_length: 'Le prénom doit comporter au moins 2 caractères',
    first_name_max_length: 'Le prénom doit comporter au maximum 20 caractères',
    last_name: 'Nom',
    last_name_required: 'Le nom est obligatoire',
    last_name_min_length: 'Le nom doit comporter au moins 2 caractères',
    last_name_max_length: 'Le nom doit comporter au maximum 20 caractères',
    birth_date: 'Date de naissance',
    birth_date_required: 'La date de naissance est obligatoire',
    country: 'Pays',
    complete_profile: 'Compléter le profil',
    success: 'Profil mis à jour avec succès !',
    error: 'Échec de la mise à jour du profil',
  },
  language: {
    select: 'Choisissez votre langue',
    select_country: 'Où êtes-vous ?',
    select_language: 'Quelle langue ?',
    current: 'Langue actuelle',
  },
  categories: {
    title: 'Catégories de nourriture',
    meta: {
      title: 'Catégories de nourriture - Découvrez des délices culinaires',
      description:
        'Explorez nos diverses catégories de nourriture et découvrez des délices culinaires du monde entier. Trouvez des avis, des notes et où les déguster.',
      categoryTitle: 'Catégorie de nourriture',
      categoryDescription:
        "Explorez {{category}} - Découvrez {{count}} délicieux plats dans cette catégorie avec des avis et des notes d'amateurs de nourriture.",
      keywords:
        'catégories de nourriture, types de cuisine, exploration culinaire, découverte de nourriture',
      loading: 'Chargement de la catégorie',
      defaultDescription:
        'Explorez nos diverses catégories de nourriture et trouvez votre prochaine aventure culinaire.',
    },
  },
  common: {
    noMoreReviews: 'Plus de commentaires',
    save: 'Sauvegardez-le',
    error: {
      default: 'Oups!',
      fetchFailed: 'Échec de la récupération des données',
      rateLimitExceeded: 'Trop de demandes. Veuillez patienter et réessayer.',
    },
    search: 'Rechercher',
    back: 'Retour',
    cancel: 'Annuler',
    loading: 'Chargement...',
    delete: 'Supprimer',
    create: 'Créer',
    open: 'Ouvert',
    closed: 'Fermé',
    country: 'Pays',
    reviews: 'Avis',
    reviews_count: '{{count}} gourmets ont essayé ceci',
    showMore: 'Voir plus',
    showLess: 'Voir moins',
    uploadImage: 'Télécharger une image',
    uploadMedia: 'Télécharger un média',
    sort: 'Trier par',
    loadMore: 'Charger plus',
    backToHome: "Retour à l'accueil",
    actions: {
      share: {
        label: 'Partager',
        copied: 'Lien copié dans le presse-papiers',
        copyFailed: 'Échec de la copie du lien'
      },
    },
    exploreMore: 'Explorer Plus',
    discoverExperiences: 'Découvrez de nouvelles expériences culinaires',
    reachedEndOfContent: 'Vous avez atteint la fin de ce contenu',
    next: 'Suivant',
    previous: 'Précédent',
    deleteMedia: 'Supprimer le média',
    uploadedMedia: 'Média téléchargé',
    comingSoon: 'Bientôt disponible',
    notNow: 'Pas maintenant',
    close: 'Fermer',
    saveChanges: 'Enregistrer les modifications',
    food: 'nourriture',
  },
  statuses: {
    active: 'Actif',
    pending: 'En attente',
    rejected: 'Rejeté',
  },
  places: {
    radius: 'Distance',
    noPlacesFound: 'Rien ici pour le moment',
    tryAdjustingFilters: "Essayez d'ajuster vos options de recherche",
    locationPermission: {
      title: 'Où souhaitez-vous explorer ?',
      description: 'Activez la localisation pour trouver d\'excellents endroits à proximité ou recherchez un lieu spécifique.',
      allow: 'Utiliser ma position'
    },
    whereDidYouEat: 'Où avez-vous mangé cela ?',
    searchByLocation: 'Où voulez-vous aller ?',
    selectPlace: 'Rechercher un lieu...',
    yourLocation: 'Votre position',
    searchOrUseLocation: 'Recherchez un lieu ou utilisez votre position pour commencer.',
    locationStatus: {
      detecting: 'Recherche de votre position...',
      denied: 'Accès à la localisation refusé',
      unavailable: 'Localisation indisponible',
      found: 'Position trouvée !'
    },
    sort: {
      title: 'Trier par',
      ratingDesc: 'Mieux notés', 
      ratingAsc: 'Moins bien notés',
      distanceAsc: 'Plus proches d\'abord',
      distanceDesc: 'Plus éloignés d\'abord',
      nameAsc: 'Nom (A-Z)',
      nameDesc: 'Nom (Z-A)',
      reviewCountDesc: 'Plus commentés',
      reviewCountAsc: 'Moins commentés',
      newestFirst: 'Plus récents d\'abord',
      oldestFirst: 'Plus anciens d\'abord'
    },
    period: {
      title: 'Période',
      ALL_TIME: 'Tout le temps',
      LAST_WEEK: 'Semaine dernière',
      LAST_MONTH: 'Mois dernier',
      LAST_YEAR: 'Année dernière'
    },
    meta: {
      title: 'Découvrez les restaurants près de chez vous',
      description: 'Trouvez et explorez les meilleurs restaurants de votre région. Lisez les avis, consultez les photos et découvrez de nouvelles expériences culinaires.',
      titleWithPlace: 'Meilleurs endroits près de {{place}}',
      descriptionWithPlace: 'Découvrez les meilleurs restaurants et lieux de restauration près de {{place}} dans un rayon de {{radius}} km. Lisez les avis, consultez les évaluations et trouvez votre prochain restaurant préféré.'
    },
    navigation: {
      title: 'Lieux',
    },
    detail: {
      error: "Oups ! Nous n'avons pas pu trouver ce lieu. Réessayez ?",
      sections: {
        popularFoods: {
          title: 'Les plus appréciés chez {{place}}',
          description:
            "Ces plats sont les plus appréciés par notre communauté de gourmets chez {{place}}. Classés par notes et nombre d'avis.",
          titleWithCity: 'Les plus appréciés chez {{place}} à {{city}}',
          descriptionWithCity:
            "Ces plats sont les plus appréciés par notre communauté de gourmets chez {{place}} à {{city}}. Classés par notes et nombre d'avis.",
        },
        gourmets: {
          title: 'Meilleurs gourmets chez {{place}}',
          description:
            "Rencontrez les amateurs de nourriture qui connaissent le mieux {{place}}. Ils sont classés par leur nombre d'avis et leurs notes.",
          titleWithCity: 'Meilleurs gourmets chez {{place}} à {{city}}',
          descriptionWithCity:
            "Rencontrez les amateurs de nourriture qui connaissent le mieux {{place}} à {{city}}. Ils sont classés par leur nombre d'avis et leurs notes.",
        },
        reviews: {
          title: 'Avis sur {{place}}',
          titleWithCity: 'Avis sur {{place}} à {{city}}',
        },
      },
    },
    emptyState: {
      title: 'Aucun lieu trouvé',
      description: '{{username}} n\'a pas encore évalué de lieux.'
    },
    userMapTitle: 'Carte gastronomique de {{username}}',
    reviewsDrawer: {
      title: 'Avis pour {{placeName}}',
      noReviews: 'Pas encore d\'avis pour cet endroit.',
      viewMore: 'Voir tous les avis',
      addReview: 'Ajouter un avis'
    },
    viewAllVisited: 'Tous les endroits que {{username}} a visités et évalués'
  },
  settings: {
    title: 'Vos paramètres',
  },
  home: 'Accueil',
  'review-not-found': 'Impossible de trouver cet avis',
  'go-back': 'Retour',
  actions: {
    share: 'Partager avec des amis'
  },
  users: {
    title: 'Passionnés de Cuisine',
    searchPlaceholder: 'Rechercher par nom...',
    noResults: 'Aucun passionné trouvé',
    seoTitle: 'Critiques Gastronomiques et Évaluateurs',
    seoDescription:
      'Découvrez des critiques gastronomiques et des évaluateurs dans votre région. Connectez-vous avec des passionnés de cuisine qui partagent vos passions culinaires et découvrez de nouvelles expériences gastronomiques.',
    seoKeywords:
      'critiques gastronomiques, évaluateurs culinaires, experts culinaires, passionnés de cuisine, amateurs de gastronomie',
    navigation: {
      title: 'Gourmets',
    },
    stats: {
      followers: 'Abonnés',
      following: 'Abonnements',
      rating: 'Note',
      reviews: 'Avis',
    },
    map: {
      viewMap: 'Voir la carte gastronomique',
      seoTitle: 'Carte gastronomique de {{username}}',
      seoDescription: 'Explorez les lieux que {{username}} a visités et évalués sur sa carte gastronomique.'
    },
    detail: {
      sections: {
        visitedPlaces: {
          title: 'Lieux récents de {{username}}',
          description: 'Endroits où {{username}} a partagé ses expériences culinaires',
        },
        likedFoods: {
          title: 'Plats préférés de {{username}}',
          description: 'Plats que {{username}} a essayés et évalués',
        }
      }
    },
  },
  foods: {
    title: 'Plats',
    meta: {
      title: 'Découvrez des plats près de chez vous',
      description:
        'Explorez et découvrez de délicieux plats dans votre région. Parcourez les avis, les notes et les photos de divers plats des restaurants locaux.',
    },
    searchPlaceholder: 'Rechercher des plats...',
    noResults: 'Aucun plat trouvé',
    sort: {
      nameAsc: 'Nom A-Z',
      nameDesc: 'Nom Z-A',
      ratingDesc: 'Mieux notés',
      ratingAsc: 'Moins bien notés',
      reviewCountDesc: "Plus d'avis",
      reviewCountAsc: "Moins d'avis",
    },
    period: {
      allTime: 'Tout le temps',
      lastWeek: 'Dernière semaine',
      lastMonth: 'Dernier mois',
      lastYear: 'Dernière année',
    },
  },
  navigation: {
    home: 'Accueil',
    discover: 'Découvrir',
    popular: 'Populaire',
    community: 'Communauté',
    placesNearMe: 'Lieux près de moi',
    foodsNearMe: 'Plats près de moi',
    popularFoodsMonth: 'Plats populaires du mois',
    popularPlacesMonth: 'Lieux les mieux notés du mois',
    mostReviewedPlacesMonth: 'Lieux les plus commentés du mois',
    myFeed: 'Mon fil',
    myProfile: 'Mon profil',
    popularGourmetsMonth: 'Gourmets populaires du mois',
    support: 'Support',
    contact: 'Contact',
    privacy: 'Politique de Confidentialité',
    terms: 'Conditions Générales',
    gourmets: 'Trouver des gourmets'
  },
  error: {
    pageNotFound: 'Page non trouvée',
    pageNotFoundDescription:
      'La page que vous recherchez a peut-être été supprimée, a changé de nom ou est temporairement indisponible.',
    needHelp: "Besoin d'aide ?",
    contactUs:
      'Contactez notre équipe de support et nous vous aiderons à trouver ce que vous cherchez.',
  },
  contact: {
    title: 'Contactez-nous',
    name: 'Votre nom',
    email: 'Adresse e-mail',
    message: 'Message',
    send: 'Envoyer le message',
    nameRequired: 'Veuillez entrer votre nom',
    emailRequired: 'Veuillez entrer votre e-mail',
    emailInvalid: 'Veuillez entrer un e-mail valide',
    messageRequired: 'Veuillez entrer votre message',
    pageTitle: 'Prenez contact',
    pageDescription:
      "Vous avez des questions ou besoin d'assistance ? Nous sommes là pour vous aider ! Remplissez le formulaire ci-dessous ou envoyez-nous un e-mail directement.",
  },
  seo: {
    keywords: {
      food: 'nourriture',
      cuisine: 'cuisine',
      reviews: 'avis',
      rating: 'note',
      restaurants: 'restaurants',
      dining: 'restauration',
    },
    food: {
      title: 'Avis sur {{foodName}}',
      description:
        'Découvrez les meilleurs endroits pour manger {{foodName}}. Lisez des avis honnêtes et trouvez où déguster la plus délicieuse {{foodName}} près de chez vous sur BiteCritic.',
      defaultDescription:
        'Découvrez {{foodName}} - avis, notes et où trouver le meilleur {{foodName}} près de chez vous.',
    },
    place: {
      defaultDescription:
        'Explorez {{placeName}} - avis, notes et plats populaires à cet endroit.',
      cityDescription:
        'Explorez {{placeName}} dans {{cityName}} - avis, notes et plats populaires à cet endroit.',
    },
    review: {
      defaultDescription:
        "Lisez l'avis de {{username}} sur {{foodName}} chez {{placeName}} - notes, photos et expérience détaillée.",
      foodTitle: 'Avis sur {{foodName}} chez {{placeName}} - {{rating}}/10',
      placeTitle: 'Avis sur {{placeName}} - {{rating}}/10',
      metaDescription:
        "Lisez l'avis détaillé de {{username}} sur {{foodName}} chez {{placeName}}. Note: {{rating}}/10. Découvrez ce qui rend ce {{type}} spécial.",
      authorTitle: 'Avis de {{username}} sur {{foodName}} chez {{placeName}}',
      ratingScale: 'Échelle de notation: 0-10',
      reviewedType: {
        food: 'Plat',
        restaurant: 'Restaurant',
        product: 'Produit',
      },
    },
    user: {
      defaultDescription:
        'Découvrez le parcours culinaire de {{username}} - avis, plats préférés et aventures culinaires.',
    },
    category: {
      defaultDescription:
        'Explorez les plats de {{categoryName}} - découvrez les meilleurs plats, avis et où les trouver près de chez vous.',
    },
    meta: {
      siteName: 'BiteCritic',
      defaultTitle:
        'BiteCritic - Découvrez et partagez des expériences culinaires',
      defaultDescription:
        "Rejoignez les amateurs de nourriture du monde entier pour découvrir et partager d'incroyables expériences culinaires. Trouvez des avis authentiques, des notes et des photos de plats près de chez vous.",
      defaultKeywords:
        'nourriture, restaurants, avis, gastronomie, cuisine, critiques gastronomiques',
    },
  },
  feed: {
    title: 'Votre parcours culinaire personnel',
    description:
      'Suivez vos plats, lieux et gourmets préférés pour créer votre fil culinaire parfait. Obtenez des recommandations personnalisées et ne manquez jamais un bon repas.',
    discover: 'Commencer à découvrir',
    personalizedTitle: 'Votre fil culinaire',
    allReviewsTitle: 'Dernières histoires culinaires',
    personalizedDescription:
      'Consultez les avis des plats, lieux et gourmets que vous suivez.',
    joinCommunityDescription:
      'Rejoignez notre communauté pour un fil personnalisé basé sur vos intérêts.',
    noRelatedReviews:
      "Nous n'avons pas encore d'avis correspondant à vos intérêts. Découvrons quelques histoires globales !",
    showGlobalFeed: 'Afficher le fil global',
    myFeed: 'Mon fil',
    globalFeed: 'Fil global',
    globalDescription:
      'Découvrez les dernières histoires culinaires du monde entier.',
    noGlobalReviews:
      "Aucun avis global n'est disponible pour le moment. Revenez bientôt !",
    meta: {
      title: 'Fil culinaire - Votre parcours culinaire personnalisé',
      description:
        'Découvrez les derniers avis et histoires culinaires de vos plats, lieux et gourmets préférés. Obtenez des recommandations personnalisées basées sur vos goûts.',
      keywords:
        'fil culinaire, avis sur la nourriture, recommandations personnalisées, histoires culinaires, communauté culinaire',
    },
    followFoods: {
      title: 'Suivre des plats',
      description:
        'Gardez une trace de vos plats préférés et découvrez de nouvelles variations.',
    },
    followPlaces: {
      title: 'Suivre des lieux',
      description: 'Restez informé des derniers avis de vos endroits préférés.',
    },
    followGourmets: {
      title: 'Suivre des gourmets',
      description:
        'Connectez-vous avec des amateurs de nourriture qui partagent vos goûts et découvrez leurs recommandations.',
    },
  },
  app: {
    actions: "Actions de l'application",
  },
  download: {
    ios_app: "Télécharger l'application iOS",
    android_app: "Télécharger l'application Android",
  },
  notifications: {
    title: 'Notifications',
    pageTitle: 'Notifications',
    pageDescription: 'Gérer vos notifications',
    markAllAsRead: 'Tout marquer comme lu'
  },
  endOfScroll: {
    placesNearMe: 'Lieux à Proximité',
    placesNearMeSubtitle:
      'Trouvez des restaurants et établissements près de chez vous',
    globalFeed: 'Fil Mondial',
    globalFeedSubtitle: 'Voyez ce que les autres apprécient',
    findPeople: 'Trouvez des Gourmets',
    findPeopleSubtitle: "Connectez-vous avec d'autres amateurs de cuisine",
    foodsNearMe: 'Plats à Proximité',
    foodsNearMeSubtitle: 'Découvrez les plats populaires dans votre région',
  },
  'location': 'Lieu',
  'review-modal-media-explanation': 'Prenez une photo ou choisissez-en une de votre album pour montrer votre plat !',
  'review-modal-rating-explanation': 'Quel goût avait-il ? Donnez votre évaluation honnête.',
  'review-modal-location-explanation': 'Où avez-vous dégusté ce plat ? Faites-le savoir aux autres !',
  'draft-cleared': 'Brouillon effacé avec succès !',
  'draft-save-error': 'Oups ! Impossible de sauvegarder votre brouillon',
  'clear-draft': 'Effacer le brouillon',
  comments: {
    title: 'Commentaires',
    subtitle: 'Rejoignez la conversation',
    writeComment: 'Écrire un commentaire...',
    submit: 'Publier',
    delete: 'Supprimer',
    noComments: 'Pas encore de commentaires. Soyez le premier à commenter !',
    loginToComment: 'Veuillez vous connecter pour laisser un commentaire',
    loadMore: 'Charger plus',
    commentAdded: 'Commentaire ajouté avec succès',
    commentError: 'Échec de l\'ajout du commentaire',
    commentDeleted: 'Commentaire supprimé',
    deleteError: 'Échec de la suppression du commentaire',
    post: 'Publier',
    placeholder: 'Écrire un commentaire...',
  },
  mentions: {
    noUsersFound: 'Aucun utilisateur trouvé',
    searchingUsers: 'Recherche d\'utilisateurs...',
  },
};

export default translations;
